// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import ProductQuickViewtModal from "@bg/App/Components/QuickViewModal";
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import ManageShareListModal from "@insite/content-library/Components/ManageShareListModal";
import ProductDeliveryScheduleModal from "@insite/content-library/Components/ProductDeliveryScheduleModal";
import ProductSelectorVariantModal from "@insite/content-library/Components/ProductSelectorVariantModal";
import ShareListDetailModal from "@insite/content-library/Components/ShareListDetailModal";
import ShareListModal from "@insite/content-library/Components/ShareListModal";
import * as React from "react";

interface OwnProps {
    skipInventoryValidation?: boolean;
    skipProductPrice?: boolean;
}

type Props = OwnProps

const Modals = ({ skipInventoryValidation, skipProductPrice }: Props) => (
    <>
        <AddToListModal />
        <ShareListModal />
        <ManageShareListModal />
        <ShareListDetailModal />
        <ProductSelectorVariantModal
            skipInventoryValidation={skipInventoryValidation}
            skipProductPrice={skipProductPrice}
        />
        <ProductDeliveryScheduleModal />
        {/* Xng-Change */}
        <ProductQuickViewtModal />
    </>
);

export default Modals;
